<template>
  <div style>
    <el-card class="box-card">
      <div>
        <div class="item">订单编号：{{order.id}}</div>
        <div class="item">设备编号：{{order.deviceId}}</div>
        <div class="item">套餐名称：{{order.orderPackage.packageName}}</div>
        <div class="item">订单金额：{{order.orderPackage.packagePrice*order.quantity}}</div>
        <div class="item">订单状态：{{orderStatus[order.status]}}</div>
        <div class="item">
          选择支付方式：
          <el-radio class="item-radio" v-model="payMethod" :label="1">支付宝</el-radio>
        </div>
        <div class="item center">
          <el-button type="primary" @click="start">立刻支付</el-button>
        </div>
      </div>
    </el-card>
  </div>
</template>
<script>
export default {
  data() {
    return {
      order: {
        id: null,
        deviceId: null,
        quantity: null,
        status: null,
        orderPackage: {}
      },
      payMethod: 1,
      orderStatus: ["待支付", "启动中", "启动成功", "启动失败", "订单关闭"]
    };
  },
  created: function() {
    let that = this;
    let id = that.$route.query.id;
    if (!id) {
      that.$message({
        message: "订单id不存在请重新扫码！",
        type: "warning",
        duration: 2000,
        onClose: function() {}
      });
    } else {
      this.api.client.getOrder({ id: id }).then(response => {
        if (!response.data.errorCode) {
          Object.assign(that.order, response.data.data);
        }
      });
    }
  },
  methods: {
    start: function() {
      let that = this;
      let id = that.$route.query.id;
      if (!id) {
        that.$message({
          message: "订单id不存在请重新扫码！",
          type: "warning",
          duration: 2000,
          onClose: function() {}
        });
      } else {
        this.api.client
          .payOrder({
            orderId: that.$route.query.id,
            payMethod: that.payMethod,
            returnUrl:
              location.origin + `/#/client/main/pay/${that.$route.query.id}`
          })
          .then(response => {
            if (!response.data.errorCode) {
              let body = response.data.data.body;
              body = body.replace("<form ", '<form accept-charset="utf-8" ');
              document.write(body);
              //console.log(body);
              // that.$router.push({
              //   path: "order",
              //   query: { id: response.data.data.id }
              // });
            }
          });
      }
    }
  }
};
</script>
<style scoped>
.item {
  padding: 12px;
  font-size: 14px;
}
.center {
  text-align: center;
  padding: 30px;
}
.item-radio {
  width: 100%;
  margin-left: 0px;
  line-height: 35px;
}
</style>


// WEBPACK FOOTER //
// order.vue?43ee7e18